import { render, staticRenderFns } from "./AddCheckbox.vue?vue&type=template&id=821837a8&scoped=true"
import script from "./AddCheckbox.vue?vue&type=script&lang=js"
export * from "./AddCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AddCheckbox.vue?vue&type=style&index=0&id=821837a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821837a8",
  null
  
)

export default component.exports